<template>
  <v-card outlined>
    <template v-if="sectionModules && sectionModules.length">
      <draggable
        v-model="sectionModules"
        tag="v-expansion-panels"
        :component-data="{ props: { flat: true, accordion: true } }"
        @change="$emit('input', sectionModules)"
      >
        <module-block
          v-for="(module, index) of sectionModules"
          :key="index"
          :module="module"
          :modules="modules"
          :template-options="templateOptions"
          :is-loading="isLoading"
          :readonly="readonly"
          @delete="onModuleDelete(index)"
          @input="onInput($event, index)"
        />
      </draggable>
    </template>

    <div class="d-flex align-center pa-4">
      <select-list
        v-model="newModuleId"
        :items="moduleOptions"
        :disabled="readonly"
        class="mr-4"
        label="Module Select"
        clearable
        hide-details
      />
      <v-btn :disabled="!newModuleId" color="primary" depressed @click="onModuleAdd">
        <v-icon left>add</v-icon>
        <span>Add Module</span>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
// Helpers
import Vue from 'vue'
import Draggable from 'vuedraggable'
import { snakeCase } from 'lodash-es'
// Components
import { VExpansionPanels } from 'vuetify/lib'
import SelectList from '@/components/forms/select-list'

const blankModule = ({ id, name }, suffix) => ({
  id,
  key: snakeCase([name, suffix]),
  template_options: [],
})

Vue.component('v-expansion-panels', VExpansionPanels)

export default {
  name: 'ModuleBlockGroup',
  components: {
    ModuleBlock: () => import('./module-block'),
    Draggable,
    SelectList,
  },
  model: {
    prop: 'sectionModules',
  },
  props: {
    sectionModules: {
      type: Array,
      default: null,
    },
    templateOptions: {
      type: Array,
      required: true,
    },
    modules: {
      type: Array,
      required: true,
    },
    sections: {
      type: Object,
      required: true,
    },
    section: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    newModuleId: null,
  }),
  computed: {
    moduleOptions() {
      return this.modules.map(({ name: key, id: value }) => ({ key, value }))
    },
  },
  methods: {
    onModuleAdd() {
      const module = this.modules.find(({ id }) => id === this.newModuleId)
      const existingModules = Object.entries(this.sections)
        .flatMap(([, modules]) => modules)
        .filter(({ id }) => id === this.newModuleId)

      this.$emit('input', [
        ...this.sectionModules,
        blankModule(module, existingModules.length ? existingModules.length + 1 : ''),
      ])

      this.newModuleId = null
    },
    onModuleDelete(index) {
      this.$emit('input', this.sectionModules.slice(0, index).concat(this.sectionModules.slice(index + 1)))
    },
    onInput(module, index) {
      const input = this.sectionModules
        .slice(0, index)
        .concat(module)
        .concat(this.sectionModules.slice(index + 1))

      this.$emit('input', input)
    },
  },
}
</script>
